import { Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

const TEAMS = [
  { id: "booker", title: "Booker", people: [["Gergana Dimitrova", "gergana@youthmanagement.com"], ["Marco La Sorte", "marco@youthmanagement.com"]] },
  { id: "scouting", title: "Scouting", people: [["Rebecca Klimova"], ["Giulia Zaffaroni"], ["Valeria Viola"]], email: "scouting@youthmanagement.com" },
  { id: "general", title: "General inquiries", email: "info@youthmanagement.com" },
  { id: "financial", title: "Financial", email: "financial@youthmanagement.com" },
];

const MailLink = ({ email, id }) => (
  <a href={`mailto:${email}`} data-testid={id} className="group inline-flex items-center gap-2 break-all text-base underline-offset-4 hover:underline md:text-lg">
    {email} <ArrowUpRight className="h-4 w-4 shrink-0 text-[#e9458f] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </a>
);

const TeamRow = ({ t, i }) => (
  <Reveal delay={i * 0.05}>
    <div data-testid={`contact-team-${t.id}`} className="grid gap-6 border-t border-[#1c1418]/15 py-10 md:grid-cols-12">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#1c1418]/70 md:col-span-3">{String(i + 1).padStart(2, "0")} · {t.title}</p>
      <div className="space-y-5 md:col-span-9">
        {(t.people || []).map(([name, email]) => (
          <div key={name} className="flex flex-col gap-1 md:flex-row md:items-baseline md:justify-between">
            <p className="font-display text-4xl uppercase leading-none md:text-6xl">{name}</p>
            {email && <MailLink email={email} id={`contact-email-${email.split("@")[0]}`} />}
          </div>
        ))}
        {t.email && <MailLink email={t.email} id={`contact-email-${t.email.split("@")[0]}`} />}
      </div>
    </div>
  </Reveal>
);

export default function Contact() {
  return (
    <main data-testid="contact-page" className="min-h-screen bg-white px-5 pb-24 pt-32 text-[#1c1418] md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <p className="font-mono text-xs uppercase tracking-[0.25em]">Contact · Milano</p>
        <h1 className="mt-4 font-display text-6xl uppercase leading-[0.85] sm:text-7xl lg:text-[9rem]">Let's talk.</h1>
        <p className="mt-6 max-w-md font-serif text-xl italic text-[#1c1418]/75">Bookings, castings and new faces. Write to the right team and we'll get back to you.</p>
        <div className="mt-16">{TEAMS.map((t, i) => <TeamRow key={t.id} t={t} i={i} />)}</div>
        <div className="grid gap-8 border-t-2 border-[#1c1418] pt-10 sm:grid-cols-3">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">Office</p>
            <p data-testid="contact-address" className="mt-3 text-lg">Via Tortona 16<br />20144 Milano</p>
          </div>
          <a data-testid="contact-whatsapp" href="https://wa.me/393341726456" target="_blank" rel="noopener noreferrer" className="block">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">WhatsApp</p>
            <p className="mt-3 flex items-center gap-2 text-lg hover:underline"><MessageCircle className="h-5 w-5 text-[#e9458f]" /> +39 3341726456</p>
          </a>
          <a data-testid="contact-instagram" href="https://www.instagram.com/youth_mgmt/" target="_blank" rel="noopener noreferrer" className="block">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">Instagram</p>
            <p className="mt-3 flex items-center gap-2 text-lg hover:underline"><Instagram className="h-5 w-5 text-[#e9458f]" /> @youth_mgmt</p>
          </a>
        </div>
      </div>
    </main>
  );
}
